import { AuthState, RootState } from "./state_models";
import { Module, ActionContext } from "vuex";
import localStorage from "store";
import { AuthService } from "@/services";
import { TokenDetails } from "@/types";
import { Role, Module as SupportModule } from "@/constants";

export const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state: {},
  getters: {
    userHasPermission: (state) => (module: SupportModule, role: Role) => {
      const userRole = state.user?.permissions[module];
      if (!userRole) return false;
      return userRole >= role;
    },
  },
  mutations: {
    setTokenDetails: (state: AuthState, payload: TokenDetails) => {
      state.tokenDetails = { ...payload };
    },
    setUser: (state: AuthState, user: any) => {
      state.user = { ...user };
    },
    delete: (state: AuthState) => {
      delete state.tokenDetails;
      delete state.user;
    },
  },
  actions: {
    generateToken: async (
      context: ActionContext<AuthState, RootState>,
      payload: { code: string; state: string }
    ) => {
      const { data } = await AuthService.generateToken({
        code: payload.code,
        state: payload.state,
      });
      localStorage.set("a", btoa(JSON.stringify(data)));
      context.commit("setTokenDetails", data);
    },
    getToken: (context: ActionContext<AuthState, RootState>) => {
      if (context.state.tokenDetails) return context.state.tokenDetails;
      const dataInLocalStorage = localStorage.get("a");
      if (dataInLocalStorage) {
        const data = JSON.parse(atob(dataInLocalStorage));
        context.commit("setTokenDetails", data);
        return data;
      } else return null;
    },
    authorized: async (context: ActionContext<AuthState, RootState>) => {
      const existingToken = await context.dispatch("getToken");
      if (!existingToken) return { authorized: false };
      try {
        const { data } = await AuthService.verifyToken();
        context.commit("setUser", data);
        return { authorized: true };
      } catch (error) {
        context.dispatch("logout");
        return {
          authorized: false,
          error: "Please login again - Invalid / Expired token",
        };
      }
    },
    logout: (context: ActionContext<AuthState, RootState>) => {
      context.commit("delete");
      localStorage.remove("a");
    },
  },
};
